import React from 'react';
import { MapPin, Shield, ClipboardCheck, Users } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const TEAM_IMAGES = [
  {
    src: `${API}/api/cars/images/team/jetour_container.jpg`,
    alt: "Jetour vehicle loaded into shipping container at Shanghai port",
    caption: "Container Loading — Jetour Export"
  },
  {
    src: `${API}/api/cars/images/team/container_loading.webp`,
    alt: "Workers securing vehicle inside shipping container",
    caption: "Securing Cargo for Transit"
  },
  {
    src: `${API}/api/cars/images/team/jetour_showroom.webp`,
    alt: "RunTheRays team member at Jetour showroom with vehicle",
    caption: "Jetour Showroom Sourcing"
  },
  {
    src: `${API}/api/cars/images/team/jetour_discuss1.webp`,
    alt: "Team discussing procurement details at Jetour dealership",
    caption: "Supplier Negotiation — Jetour"
  },
  {
    src: `${API}/api/cars/images/team/jetour_discuss2.webp`,
    alt: "Close-up of procurement discussion at Jetour",
    caption: "Reviewing Specifications"
  },
  {
    src: `${API}/api/cars/images/team/vw_lounge.webp`,
    alt: "Business meeting at FAW-Volkswagen dealership lounge",
    caption: "FAW-Volkswagen Partnership Meeting"
  }
];

const stats = [
  { icon: Shield, value: "500+", label: "Factory Audits Completed" },
  { icon: ClipboardCheck, value: "99.2%", label: "Shipment Pass Rate" },
  { icon: MapPin, value: "15+", label: "Chinese Provinces Covered" },
  { icon: Users, value: "12", label: "On-ground Team Members" }
];

const TeamSection = () => (
  <section id="team" className="py-16 sm:py-24 bg-blue-950" data-testid="team-section">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      {/* Section Header */}
      <div className="text-center mb-12">
        <span className="text-orange-400 font-semibold text-sm uppercase tracking-widest">On The Ground</span>
        <h2 className="text-3xl sm:text-4xl font-bold text-white mt-2">Our Local Presence in China</h2>
        <p className="text-blue-200/70 mt-3 max-w-xl mx-auto text-base">
          Our dedicated team operates across China's major manufacturing hubs, conducting factory audits, quality inspections, and logistics coordination in person.
        </p>
      </div>

      {/* Photo Grid */}
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4 mb-14">
        {TEAM_IMAGES.map(img => (
          <div key={img.caption} className="group relative rounded-xl overflow-hidden aspect-[4/3]">
            <img
              src={img.src}
              alt={img.alt}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-950/80 via-transparent to-transparent" />
            <p className="absolute bottom-3 left-3 right-3 text-white text-xs sm:text-sm font-semibold drop-shadow-lg">
              {img.caption}
            </p>
          </div>
        ))}
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
        {stats.map(stat => (
          <div key={stat.label} className="bg-white/5 border border-white/10 rounded-xl p-5 text-center hover:bg-white/10 transition-colors duration-300">
            <stat.icon size={24} className="text-orange-400 mx-auto mb-3" />
            <p className="text-2xl sm:text-3xl font-bold text-white">{stat.value}</p>
            <p className="text-blue-200/60 text-xs mt-1 font-medium">{stat.label}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TeamSection;
